/**
 * Created by contrapro on 2018/4/16
 */


import {
    ACTION_TYPE_UPDATE_VIEW_STATE,
    ACTION_TYPE_TOGGLE_SHARE_PANEL
} from '../actions';

import { VIEW_STATE} from '../util/constConfig';


const initialState = {
    viewState: VIEW_STATE.HOME,
    showShare: false
};

export default function viewStateReducer(state = initialState, action) {
    //console.log(action);
    switch (action.type) {

        case ACTION_TYPE_UPDATE_VIEW_STATE:
            //console.log('ACTION_TYPE_UPDATE_LOCAL_USER',{ ...state, ...action.payload.data });
            let t = action.payload.viewState;

            t = (t===null || t==='null' || t===undefined) ? VIEW_STATE.NORMAL : t;

            return {
                ...state,
                viewState:t
            };

        case ACTION_TYPE_TOGGLE_SHARE_PANEL:
            return {
                ...state,
                showShare: action.payload.visible
            };

        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/viewStateReducer.js